// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format3 } from '../../constants';

/** Western Sahara */
const EH: PhoneNumberData = [
  212,
  'EH',
  9,
  format3,
  /^(?:(?:6(?:[0-79]|8[0-247-9])|7(?:[016-8]|2[0-8]|3[01]|5[0-5])))/,
];

export default EH;
